<script lang="ts" module>
  import BaseBtn from '@/ui/base/BaseBtn.svelte';
  import Icon from '@/ui/base/icon/Icon.svelte';

  export interface PaginationProps {
    pages: number;
    current: number;
    onPageChange?: (page: number) => void;
  }
</script>

<script lang="ts">
  let {
    pages: pageCount = 1,
    current: currentProp = $bindable(),
    ...props
  }: PaginationProps = $props();

  function switchPage(dir: 'back' | 'forward'): void {
    if (currentProp < pageCount && dir === 'forward') currentProp++;
    else if (currentProp > 0 && dir === 'back') currentProp--;
  }

  $effect(() => {
    props.onPageChange?.(currentProp);
  });

  $effect(() => {
    if (currentProp < 0) currentProp = 0;
    if (currentProp > pageCount - 1) currentProp = pageCount - 1;
  });
</script>

<div class="flex w-fit items-center">
  <BaseBtn
    onclick={() => {
      switchPage('back');
    }}
  >
    <Icon icon="KeyboardArrowLeft" class="size-4"></Icon>
  </BaseBtn>
  <p class="font-sans text-xs font-normal text-c-base">{currentProp + 1}/{pageCount}</p>
  <BaseBtn
    onclick={() => {
      switchPage('forward');
    }}
  >
    <Icon icon="KeyboardArrowRight" class="size-4"></Icon>
  </BaseBtn>
</div>
